import React from 'react';
import './EntryPage.scss';
import robotImage from '../../asset/robot.webp';

const EntryPage: React.FC = () => {
  return (
    <div className="entry-page">
      <img src={robotImage} alt="Robot" className="robot-image" />

      <div className="content-wrapper">
        <h1>Welcome to the AI Agent System</h1>
        <p>Your central hub for managing your customer experience with AI.</p>

        {/* Robot image below the welcome message */}
      </div>
    </div>
  );
};

export default EntryPage;
